import { useMutation, useQueryClient } from '@tanstack/react-query'
import { origin_point_engine_api } from '@/lib/axios-client'
import { showErrorData, showSuccessData } from '@/lib/toast'

type UnpublishOptions = {
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

export function useAdminUnpublish() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (engineId: string) =>
      origin_point_engine_api({
        url: `/admin/engines/${engineId}/unpublish`,
        method: 'PUT',
      }),
    onSuccess: () => {
      // invalidate 虽然 key 不匹配，但调用方已通过 onSuccess 回调手动 refetch
      queryClient.invalidateQueries({ queryKey: ['/admin/content'] })
      showSuccessData('已下架')
    },
    onError: (error) => {
      showErrorData('下架失败', error)
    },
  })

  return {
    unpublish: (engineId: string, options?: UnpublishOptions) => {
      mutation.mutate(engineId, options)
    },
    isPending: mutation.isPending,
  }
}
